import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Regal-Auswahl mit Kategorie-Filter passend zum Artikel-Typ +
 * optionaler KI-Vorschlag (score-basiert).
 * - datalist-Autocomplete → dropdown, akzeptiert aber auch Freitext.
 * - Wenn itemId + quantity gesetzt → automatischer Vorschlag via
 *   /api/shelves/suggest. Zeigt den Score + Grund neben dem Feld.
 */
export default function ShelfSelect({
  value, onChange, itemType, itemId, quantity,
  placeholder = "Regal (opt.)", disabled = false, testId,
}) {
  const [shelves, setShelves] = useState([]);
  const [suggestion, setSuggestion] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/shelves?with_utilization=false")
      .then((r) => setShelves(r.data || []))
      .catch(() => setShelves([]));
  }, []);

  useEffect(() => {
    setSuggestion(null); setDismissed(false);
    if (!itemId) return;
    const q = { item_id: itemId };
    if (quantity) q.quantity = quantity;
    api.get("/shelves/suggest", { params: q })
      .then((r) => setSuggestion(r.data?.best || null))
      .catch(() => setSuggestion(null));
  }, [itemId, quantity]);

  const filtered = shelves.filter((s) => {
    if (!s.active) return false;
    if (!itemType) return true;
    return s.category === itemType || s.category === "mixed";
  });

  const listId = `shelf-options-${testId || "default"}`;
  const applySuggestion = () => {
    if (!suggestion) return;
    onChange(suggestion.code);
    setDismissed(true);
  };

  return (
    <>
      <input
        list={listId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        data-testid={testId}
        className="w-full h-10 rounded-md border border-input bg-background px-3 py-2 text-sm font-mono ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50"
      />
      <datalist id={listId}>
        {filtered.map((s) => (
          <option key={s.id} value={s.code}>
            {s.name && s.name !== s.code ? `${s.name} · ${s.category}` : s.category}
          </option>
        ))}
      </datalist>
      {suggestion && !dismissed && value !== suggestion.code && (
        <button type="button" onClick={applySuggestion}
                data-testid={`${testId}-suggestion`}
                className="mt-1 inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full bg-[var(--pop-yellow)]/60 text-[var(--pop-black)] font-semibold hover:bg-[var(--pop-yellow)]">
          🤖 Vorschlag: <span className="font-mono">{suggestion.code}</span>
          <span className="text-[9px] text-[var(--text-muted)] normal-case font-normal">({suggestion.reason})</span>
        </button>
      )}
    </>
  );
}
